import { styled } from '@mui/material';

import { Row } from '/shared/Promotions/containers/Row';

export const StyledPromotionRow = styled(Row)`
  min-height: 64px;
  margin-top: 0;
`;
